import AbsolutePane from 'presentation/components/absolute-pane/index.js';
import SportIcon from 'presentation/components/sport-icon/index.js';

import SportWatermarkImageTypes from './types.js';

const SportWatermarkImage = props => {
    const { mojitoTools, sportId, position } = props;
    const { config, style } = mojitoTools;
    const imageContainerStyle = style[position] || config.imageContainer;
    return (
        <AbsolutePane class={'ta-SportWatermarkImage'} config={config.container}>
            <AbsolutePane config={imageContainerStyle}>
                <SportIcon sportId={sportId} config={config.sportIcon} class="ta-backgroundImage" />
            </AbsolutePane>
        </AbsolutePane>
    );
};

SportWatermarkImage.getStyle = (config, mode, merge) => {
    const { POSITIONS } = SportWatermarkImageTypes;
    return {
        [POSITIONS.TOP_LEFT]: merge(config.imageContainer, config.imageContainerTopLeft),
        [POSITIONS.TOP_RIGHT]: merge(config.imageContainer, config.imageContainerTopRight),
        [POSITIONS.BOTTOM_LEFT]: merge(config.imageContainer, config.imageContainerBottomLeft),
        [POSITIONS.BOTTOM_RIGHT]: merge(config.imageContainer, config.imageContainerBottomRight),
    };
};

export default SportWatermarkImage;
